"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 15, height: 14, viewBox: "0 0 15 14", fill: "none" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M7.508 1.113l1.871 3.723.118.233.258.037 4.157.594-3.004 2.875-.193.185.046.263.717 4.072-3.742-1.92-.228-.118-.229.117-3.745 1.923.705-4.075.045-.263-.192-.184L1.089 5.7l4.17-.594.26-.036.117-.234 1.872-3.723z", stroke: "#F15A22" })));
}
exports.default = SvgComponent;
